import "./Registration.scss";

import {
  Box,
  CircularProgress,
  InputAdornment,
  LinearProgress,
  SvgIcon,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import LoginLogos from "../../Assets/Images/Everest_Transparent_Logo.svg";
import { ReactComponent as MobileLoginLogo } from "../../Assets/Images/loginlogo.svg";
import { ReactComponent as LoginLogo } from "../../Assets/Images/Everest_Transparent_Logo.svg";

import { ReactComponent as ClosedEye } from "../../Assets/Images/closedEye.svg";
// import { ReactComponent as LoginLogo } from "../../Assets/Images/loginlogo.svg";
import { ReactComponent as OpenEye } from "../../Assets/Images/openEye.svg";
import Google from "../../Assets/Images/google.png";
import Facebook from "../../Assets/Images/facebook.png";
import { ReactComponent as Logmobile } from "../../Assets/Images/logomobile.svg";
import AppleAi from "../../Assets/Images/AppleAi.png";
import Background from "../../Assets/Images/loginimageAI.png";

import ButtonField from "../../Components/Button/ButtonField";
import { Link, useNavigate } from "react-router-dom";
import IconButtonField from "../../Components/Button/IconButtonField";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";

import { IRegistrationForm } from "./IRegistration";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import TextInputFieldC from "../../Components/TextInput/TextInputFieldC";
import Snackbar from "../../Components/Snackbar/Snackbar";
import {
  clearRegistrationStatus,
  registrationStart,
} from "../../Redux/Slices/Registration/RegistrationSlicer";
import {
  AuthCredential,
  FacebookAuthProvider,
  fetchSignInMethodsForEmail,
  GoogleAuthProvider,
  linkWithCredential,
  signInWithPopup,
} from "firebase/auth";
import {
  auth,
  facebookProvider,
  googleProvider,
} from "../../Components/FireBase/firebase";
import EmailIcon from "@mui/icons-material/Email";
import { GoogleloginStart } from "../../Redux/Slices/LoginSlicer/GoogleLoginSlicer";
import Select from "../../Components/Select/AutoComplete";
import NumberInputField from "../../Components/NumberInput/NumberInputField";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import { listRegistrationYeargroup } from "../../Redux/Slices/Registration/ListRegistrationYeargroupSlice";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockIcon from "../../Assets/Images/lock-02.svg";
import MailIcon from "../../Assets/Images/mail-01.svg";
import UserIcon from "../../Assets/Images/user-01.svg";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
// import EvertLogo from "../../Assets/Images/Everest logo.jpeg";
import EvertLogo from "../../Assets/Images/everest_logo.svg";

const Registration: React.FC = () => {
  const [show, setShow] = useState<boolean>(false);
  const [showconfirm, setShowconfirm] = useState<boolean>(false);

  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const nav = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(listRegistrationYeargroup());
  }, []);
  const loginResponse = useAppSelector((state) => state.RegistrationSlicer);

  const GoogleloginResponse = useAppSelector(
    (state) => state.GoogleLoginSlicer
  );

  const loginSchema = z
    .object({
      username: z
        .string({ message: "Please enter first name" })
        .min(1, { message: "Please enter first name" }),
      usernamelast: z
        .string({ message: "Please enter last name" })
        .min(1, { message: "Please enter last name" }),

      email: z.string({
        required_error: "Please enter a valid email ID",
        message: "Please enter a valid email ID",
      }),
      // year_level: z
      //   .string({ message: "Please select year group" })
      //   .min(1, { message: "Please select year group" }),
      yeargroup_country_map_id: z.number({
        message: "Please select year group",
      }),

      password: z
        .string({
          required_error: "Please enter password",
          message: "Please enter password",
        })
        .min(8, { message: "Password must be at least 8 characters long" })
        .regex(/[A-Z]/, {
          message: "Password must contain at least one uppercase letter",
        }) // Uppercase letter
        .regex(/[0-9]/, {
          message: "Password must contain at least one number",
        }) // Number
        .regex(/[@$!%*?&#^()_+=[\]{};':"\\|,.<>/?-]/, {
          message: "Password must contain at least one special character",
        }), // Special character
      confirm_password: z
        .string({
          required_error: "Please enter password",
          message: "Please enter password",
        })
        .min(8, { message: "Password must be at least 8 characters long" })
        .regex(/[A-Z]/, {
          message: "Password must contain at least one uppercase letter",
        }) // Uppercase letter
        .regex(/[0-9]/, {
          message: "Password must contain at least one number",
        }) // Number
        .regex(/[@$!%*?&#^()_+=[\]{};':"\\|,.<>/?-]/, {
          message: "Password must contain at least one special character",
        }), // Special character
    })
    .refine((data) => data.password === data.confirm_password, {
      message: " Passwords does not match",
      path: ["confirm_password"], // Point to the confirm_password field
    });

  const methods = useForm<IRegistrationForm>({
    defaultValues: {
      username: "",
      usernamelast: "",
      email: "",
      confirm_password: "",
      password: "",
      yeargroup_country_map_id: "",
    },
    resolver: zodResolver(loginSchema),
    mode: "onChange",
  });

  const onSubmit: SubmitHandler<IRegistrationForm> = (val) => {
    setIsSubmit(true);
    dispatch(
      registrationStart({
        ...val, // Spread the values of the form data
        username: `${val.username} ${val.usernamelast}`, // Explicitly set confirm_password equal to password
      })
    );
    nav("/login");
    sessionStorage.setItem("token", JSON.stringify(val));
    // nav("/dashboard");
  };

  useEffect(() => {
    return () => {
      if (!isSubmit) {
        dispatch(clearLoginStatus());
        dispatch(clearRegistrationStatus());
      }
    };
  }, []);

  const passwordValue = methods.watch("password", ""); // Watching the "password" field

  const getProgress = (passwordcheck: any) => {
    let progress = 0;
    let colorprogress = "";
    let messageprogress = "";

    // Check if the password contains a lowercase letter
    if (/[a-z]/.test(passwordcheck)) {
      progress += 30;
      colorprogress = "red";
      messageprogress = "Please enter a capital letter.";
    }

    // Check if the password contains a capital letter
    if (/[A-Z]/.test(passwordcheck)) {
      progress += 30;
      colorprogress = "yellow";
      messageprogress = "Please enter a number and special character.";
    }

    // Check if the password contains a number or a special character
    if (
      /[A-Z]/.test(passwordcheck) &&
      /\d/.test(passwordcheck) &&
      /[!@#$%^&*(),.?":{}|<>]/.test(passwordcheck)
    ) {
      progress += 40;
      colorprogress = "green";
      messageprogress = "Password strength is good.";
    }

    return { progress, colorprogress, messageprogress };
  };

  const progress = getProgress(passwordValue); // Calculate progress based on the password value

  // google resgiter

  function googleLogin() {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then(async (result) => {
        const user: any = result.user;
        console.log(user, "user ");
        if (user) {
          dispatch(
            GoogleloginStart({
              token: user?.accessToken,
              islogin: true,
            })
          );
        }
      })
      .catch((error) => {
        // Check if the error is due to the user closing the popup
        if (error.code === "auth/popup-closed-by-user") {
          alert("Popup closed before login was completed. Please try again.");
        } else {
          alert("An error occurred during login. Please try again.");
        }
      });
  }

  // facebook
  const signInWithFacebook = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      const user: any = result.user;
      console.log(user, "user");
      dispatch(GoogleloginStart({ token: user?.accessToken, islogin: true }));
    } catch (error: any) {
      console.log(error, "error facebook");
    }
  };

  // -----------------------------
  useEffect(() => {
    methods.reset({
      username: "",
      usernamelast: "",
      email: "",
      password: "",
      confirm_password: "",
      yeargroup_country_map_id: "",
    }); // Resets all form fields to default values
  }, [isSubmit, methods]);

  const getToken = sessionStorage.getItem("token");

  useEffect(() => {
    console.log("getting", getToken);
    if (loginResponse?.data !== null && getToken) {
      const timer = setTimeout(() => {
        nav("/dashboard");
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [loginResponse?.data, nav, getToken]);

  useEffect(() => {
    if (loginResponse?.data?.message === "Login successful") {
      nav("/login");
    }
  }, [loginResponse, nav]);

  useEffect(() => {
    if (
      GoogleloginResponse?.data?.message === "Login successful" &&
      GoogleloginResponse?.data?.data?.token
    ) {
      // Store the token
      sessionStorage.setItem("token", GoogleloginResponse.data.data.token);
      // Navigate to dashboard
      nav("/dashboard");
    }
  }, [GoogleloginResponse, nav]);


  const { data: listRegistrationYeargroups } = useAppSelector(
    (state) => state.ListRegistrationYeargroupSlice
  );

  const ListYearLevel = Array.isArray(listRegistrationYeargroups?.data)
    ? listRegistrationYeargroups?.data?.map((listQuestions) => ({
      label: `${listQuestions?.yeargroup?.name}-${listQuestions?.region?.name}-${listQuestions?.region?.state}`,
      value: listQuestions.id,
    }))
    : [];

  return (
    <>
      <Snackbar
        response={
          Object.keys(loginResponse.data || {}).length === 0
            ? GoogleloginResponse.data
            : loginResponse.data
        }
      />
      <div className="parent-div">
        <div className="child-div1s">
          <img
            src={Background}
            alt="AI Robot Scene"
            className="responsive-image"
          />
          <div
            className="absolute  flex items-center justify-center"
            style={{
              borderRadius: "10px",
            }}
          >
            <div className="p-[32px] W-[50%] text-center bg-white/20 backdrop-blur-md rounded-lg border border-white/30 shadow-lg">
              <Typography
                variant="h4"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  mb: 1,
                  textShadow: "0 1px 2px rgba(0,0,0,0.4)",
                  fontSize: "30px",
                }}
              >
                Your GATE Success Starts Here
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "white",
                  fontSize: "20px",
                  textShadow: "0 1px 2px rgba(0,0,0,0.3)",
                  marginTop: "10px",
                }}
              >
                Join the platform built for GATE students!
              </Typography>
            </div>
          </div>
        </div>
        <div className="child-div2">
          <div className="form-content">
            <FormProvider {...methods}>
              <form
                onSubmit={methods.handleSubmit(onSubmit)}
                style={{ display: "flex", justifyContent: "center" }}
                autoComplete="off"
              >
                <div className="main">
                  <div>
                    <div className="heading">
                      {/* <SvgIcon
                        sx={{
                          width: "70%",
                          height: "100%",
                          padding: "15px",
                        }}
                        component={LoginLogo}
                        inheritViewBox
                      /> */}

                      <img
                        src={EvertLogo}
                        alt="Everest Logo"
                        style={{ width: "300px" }}
                        onClick={() => {
                          nav("/home");
                        }}
                      />
                    </div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: "1.9rem",
                        textAlign: "center",
                      }}
                    >
                      Sign up{" "}
                    </div>

                    <div className="subHeadingss">
                      Create your account to get started!
                    </div>
                  </div>
                  {/* Social Logins */}
                  {/* Social Logins */}
                  <Box
                    style={{ textAlign: "center", margin: "15px 0" }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <ButtonField
                      sx={{
                        marginBottom: "10px",
                        cursor: "pointer",
                        border: "1px solid #64748b",
                        borderRadius: "10px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 600,
                        maxWidth: "100%",
                        width: "100%",
                        fontSize: "14px",
                        color: "black",
                      }}
                      onClick={googleLogin}
                    >
                      {/* <SvgIcon
                        sx={{ verticalAlign: "middle", marginRight: "8px" }}
                        component={Google}
                        inheritViewBox
                      /> */}
                      <img
                        src={Google}
                        alt="AI Robot Scene"
                        style={{ width: "30px" }}
                      />
                      Login with Google
                    </ButtonField>
                    <ButtonField
                      sx={{
                        marginBottom: "10px",
                        backgroundColor: "#1877F2",
                        color: "white",
                        cursor: "pointer",
                        borderRadius: "10px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 600,
                        maxWidth: "100%",
                        width: "100%",
                        fontSize: "14px",
                        "&:hover": {
                          backgroundColor: "#145dbf",
                        },
                      }}
                      onClick={signInWithFacebook}
                    >
                      {/* <SvgIcon
                        sx={{ verticalAlign: "middle", marginRight: "8px" }}
                        component={Facebook}
                        inheritViewBox
                      /> */}
                      <img
                        src={Facebook}
                        alt="AI Robot Scene"
                        style={{
                          width: "25px",
                          height: "25px",
                          color: "white",
                          marginRight: "5px",
                        }}
                      />
                      Login with Facebook
                    </ButtonField>
                    {/* <div
                      style={{
                        marginBottom: "10px",
                        cursor: "pointer",
                        borderRadius: "10px",
                        backgroundColor: "#373737",
                        color: "white",
                        fontWeight: 600,

                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={signInWithApple}
                    >
                     
                      <img
                        src={AppleAi}
                        alt="AI Robot Scene"
                        style={{
                          width: "15px",
                          color: "white",
                          marginRight: "10px",
                        }}
                      />
                      Login with Apple
                    </div> */}
                  </Box>

                  {/* Divider */}
                  <div
                    style={{
                      textAlign: "center",
                      margin: "15px 0",
                      borderTop: "1px solid #ccc",
                      lineHeight: "0.1em",
                    }}
                  >
                    <span
                      style={{
                        background: "#fff",
                        color: "#64748b",
                        padding: "0 10px",
                      }}
                    >
                      OR CONTINUE WITH
                    </span>
                  </div>

                  <div className="textFields">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "20px",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <div style={{ fontSize: "15px", fontWeight: 600 }}>
                          First Name
                        </div>
                        <TextInputFieldC
                          placeholder="John"
                          name="username"
                          type="text"
                          className="textField"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <img
                                  src={UserIcon}
                                  alt="user Icon"
                                  style={{ width: 20, height: 20 }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                      <div style={{ width: "100%" }}>
                        <div style={{ fontSize: "15px", fontWeight: 600 }}>
                          Last Name
                        </div>
                        <TextInputFieldC
                          placeholder="Doe"
                          name="usernamelast"
                          type="text"
                          className="textField"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <img
                                  src={UserIcon}
                                  alt="user Icon"
                                  style={{ width: 20, height: 20 }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    </div>
                    <div style={{ fontSize: "15px", fontWeight: 600 }}>
                      Year Level
                    </div>
                    {/* <Select
                      name="year_level"
                      placeholder="Select your year level"
                      AutoCompleteClassName="off"
                      options={YearList ?? []}
                      value={
                        YearList?.find(
                          (list) =>
                            list.value === methods.getValues("year_level")
                        ) ?? null
                      }
                      onChange={(_, value) => {
                        const val = value as AutocompleteOption;
                        methods.setValue("year_level", val?.value, {
                          shouldValidate: true,
                        });
                      }}
                    /> */}

                    <Select
                      name="yeargroup_country_map_id"
                      placeholder="Select your year level"
                      // label="Select  the Year group "
                      options={ListYearLevel ?? []}
                      value={
                        ListYearLevel?.find(
                          (list) =>
                            list.value ===
                            methods.getValues("yeargroup_country_map_id")
                        ) ?? null
                      }
                      onChange={(_, value) => {
                        const val = value as AutocompleteOption;
                        methods.setValue(
                          "yeargroup_country_map_id",
                          val?.value,
                          {
                            shouldValidate: true,
                          }
                        );
                      }}
                    />

                    <div style={{ fontSize: "15px", fontWeight: 600 }}>
                      Email
                    </div>
                    <TextInputFieldC
                      placeholder="name@example.com"
                      name="email"
                      type="email"
                      className="textField"
                      variant="outlined"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              src={MailIcon}
                              alt="Email Icon"
                              style={{ width: 20, height: 20 }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <div style={{ fontSize: "15px", fontWeight: 600 }}>
                      Password
                    </div>
                    <TextInputFieldC
                      name="password"
                      placeholder="Enter your password"
                      className="textField"
                      type={show ? "text" : "password"}
                      variant="outlined"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              src={LockIcon}
                              alt="Lock Icon"
                              style={{ width: 20, height: 20 }}
                            />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButtonField onClick={() => setShow(!show)}>
                              <SvgIcon
                                sx={{
                                  width: "20px",
                                  height: "20px",
                                  color: "white",
                                }}
                                component={show ? OpenEye : ClosedEye}
                                inheritViewBox
                              />
                            </IconButtonField>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <div style={{ fontSize: "15px", fontWeight: 600 }}>
                      Confirm Password
                    </div>
                    <TextInputFieldC
                      name="confirm_password"
                      placeholder="Confirm your password"
                      className="textField"
                      type={show ? "text" : "password"}
                      variant="outlined"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              src={LockIcon}
                              alt="Lock Icon"
                              style={{ width: 20, height: 20 }}
                            />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButtonField onClick={() => setShow(!show)}>
                              <SvgIcon
                                sx={{
                                  width: "20px",
                                  height: "20px",
                                  color: "white",
                                }}
                                component={show ? OpenEye : ClosedEye}
                                inheritViewBox
                              />
                            </IconButtonField>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  {/* Sign In Button */}
                  <div className="textFields" style={{ marginTop: "20px" }}>
                    <ButtonField
                      className="buttonfield"
                      type="submit"
                      disabled={loginResponse.isLoading}
                    >
                      Sign Up
                      {loginResponse.isLoading && (
                        <CircularProgress
                          size={24}
                          sx={{
                            color: "white",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            marginTop: "-12px",
                            marginLeft: "-12px",
                          }}
                        />
                      )}
                    </ButtonField>
                  </div>

                  {/* Sign Up */}
                  <div
                    className="subHeadingss"
                    style={{ textAlign: "center", marginTop: "15px" }}
                  >
                    Already have an account?
                    <Link
                      to="/login"
                      style={{
                        color: "#009DFF",
                        paddingLeft: "5px",
                        fontSize: "15px",
                        textDecoration: "none",
                      }}
                      onClick={() => {
                        dispatch(clearLoginStatus());
                      }}
                    >
                      Login!
                    </Link>
                  </div>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
      <div className="backGround">
        <Snackbar
          response={
            Object.keys(loginResponse.data || {}).length === 0
              ? GoogleloginResponse.data
              : loginResponse.data
          }
        />
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(onSubmit)}
            style={{ display: "flex", justifyContent: "center" }}
            autoComplete="off"
          >
            <div className="main">
              <div>
                <div className="heading">
                  <SvgIcon
                    sx={{
                      width: "70%",
                      height: "70%",
                      padding: "15px",
                      cursor: "pointer",
                    }}
                    component={MobileLoginLogo}
                    inheritViewBox
                    onClick={() => {
                      nav("/dashboard");
                    }}
                  />
                </div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "1.9rem",
                    textAlign: "center",
                  }}
                >
                  Sign up{" "}
                </div>

                <div className="subHeadingss">
                  Create your account to get started!
                </div>
              </div>
              {/* Social Logins */}
              <Box
                style={{ textAlign: "center", margin: "15px 0" }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <ButtonField
                  sx={{
                    marginBottom: "10px",
                    cursor: "pointer",
                    border: "1px solid #64748b",
                    borderRadius: "10px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 600,
                    width: "100%",
                  }}
                  onClick={googleLogin}
                >
                  {/* <SvgIcon
                                    sx={{ verticalAlign: "middle", marginRight: "8px" }}
                                    component={Google}
                                    inheritViewBox
                                  /> */}
                  <img
                    src={Google}
                    alt="AI Robot Scene"
                    style={{
                      width: "20px",
                      color: "white",
                      marginRight: "10px",
                    }}
                  />
                  Login with Google
                </ButtonField>
                <ButtonField
                  sx={{
                    marginBottom: "10px",
                    backgroundColor: "#1877F2",
                    color: "white",
                    cursor: "pointer",
                    borderRadius: "10px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 600,
                    "&:hover": {
                      backgroundColor: "#145dbf",
                    },
                    width: "100%",
                  }}
                  onClick={signInWithFacebook}
                >
                  {/* <SvgIcon
                                    sx={{ verticalAlign: "middle", marginRight: "8px" }}
                                    component={Facebook}
                                    inheritViewBox
                                  /> */}
                  <img
                    src={Facebook}
                    alt="AI Robot Scene"
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "white",
                      marginRight: "10px",
                    }}
                  />
                  Login with Facebook
                </ButtonField>
                {/* <div
                  style={{
                    marginBottom: "10px",
                    cursor: "pointer",
                    borderRadius: "10px",
                    backgroundColor: "#373737",
                    color: "white",
                    fontWeight: 600,
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
               
                  <img
                    src={AppleAi}
                    alt="AI Robot Scene"
                    style={{
                      width: "15px",
                      color: "white",
                      marginRight: "10px",
                    }}
                  />
                  Login with Apple
                </div> */}
              </Box>

              {/* Divider */}
              <div
                style={{
                  textAlign: "center",
                  margin: "15px 0",
                  borderTop: "1px solid #ccc",
                  lineHeight: "0.1em",
                }}
              >
                <span
                  style={{
                    background: "#fff",
                    color: "#64748b",
                    padding: "0 10px",
                  }}
                >
                  OR CONTINUE WITH
                </span>
              </div>

              {/* Email + Password */}
              <div className="textFields">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "20px",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <div style={{ fontSize: "15px", fontWeight: 600 }}>
                      First Name
                    </div>
                    <TextInputFieldC
                      placeholder="&#128100; John"
                      name="username"
                      type="text"
                      variant="outlined"
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <div style={{ fontSize: "15px", fontWeight: 600 }}>
                      Last Name
                    </div>
                    <TextInputFieldC
                      placeholder="&#128100; Doe"
                      name="usernamelast"
                      type="text"
                      variant="outlined"
                    />
                  </div>
                </div>
                <div style={{ fontSize: "15px", fontWeight: 600 }}>
                  Year Level
                </div>
                {/* <Select
                  name="year_level"
                  placeholder="Select your year level"
                  AutoCompleteClassName="off"
                  options={YearList ?? []}
                  value={
                    YearList?.find(
                      (list) => list.value === methods.getValues("year_level")
                    ) ?? null
                  }
                  onChange={(_, value) => {
                    const val = value as AutocompleteOption;
                    methods.setValue("year_level", val?.value, {
                      shouldValidate: true,
                    });
                  }}
                /> */}
                <Select
                  name="yeargroup_country_map_id"
                  placeholder="Select your year level"
                  // label="Select  the Year group "
                  options={ListYearLevel ?? []}
                  value={
                    ListYearLevel?.find(
                      (list) =>
                        list.value ===
                        methods.getValues("yeargroup_country_map_id")
                    ) ?? null
                  }
                  onChange={(_, value) => {
                    const val = value as AutocompleteOption;
                    methods.setValue("yeargroup_country_map_id", val?.value, {
                      shouldValidate: true,
                    });
                  }}
                />

                <div style={{ fontSize: "15px", fontWeight: 600 }}>Email</div>
                <TextInputFieldC
                  placeholder="Enter your email"
                  name="email"
                  type="email"
                  className="textField"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={MailIcon}
                          alt="Email Icon"
                          style={{ width: 20, height: 20 }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />

                <div style={{ fontSize: "15px", fontWeight: 600 }}>
                  Password
                </div>
                <TextInputFieldC
                  name="password"
                  placeholder="Enter your password"
                  className="textField"
                  type={show ? "text" : "password"}
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={LockIcon}
                          alt="Lock Icon"
                          style={{ width: 20, height: 20 }}
                        />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButtonField onClick={() => setShow(!show)}>
                          <SvgIcon
                            sx={{
                              width: "20px",
                              height: "20px",
                              color: "white",
                            }}
                            component={show ? OpenEye : ClosedEye}
                            inheritViewBox
                          />
                        </IconButtonField>
                      </InputAdornment>
                    ),
                  }}
                />

                <div style={{ fontSize: "15px", fontWeight: 600 }}>
                  Confirm Password
                </div>
                <TextInputFieldC
                  name="confirm_password"
                  placeholder="Confirm your password"
                  className="textField"
                  type={show ? "text" : "password"}
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={LockIcon}
                          alt="Lock Icon"
                          style={{ width: 20, height: 20 }}
                        />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButtonField onClick={() => setShow(!show)}>
                          <SvgIcon
                            sx={{
                              width: "20px",
                              height: "20px",
                              color: "white",
                            }}
                            component={show ? OpenEye : ClosedEye}
                            inheritViewBox
                          />
                        </IconButtonField>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              {/* Sign In Button */}
              <div className="textFields" style={{ marginTop: "20px" }}>
                <ButtonField
                  className="buttonfield"
                  type="submit"
                  disabled={loginResponse.isLoading}
                >
                  Sign Up
                  {loginResponse.isLoading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: "white",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </ButtonField>
              </div>

              {/* Sign Up */}
              <div
                className="subHeadingss"
                style={{ textAlign: "center", marginTop: "15px" }}
              >
                Already have an account?
                <Link
                  to="/login"
                  style={{
                    color: "#009DFF",
                    paddingLeft: "5px",
                    fontSize: "15px",
                    textDecoration: "none",
                  }}
                >
                  Login!
                </Link>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

export default Registration;
